import React, { useState } from "react";
import { Table, Tag, Button, Space, Avatar, Tooltip } from "antd";
import { EyeOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const MaintenancePage = () => {
  const navigate = useNavigate();

  // Example static data (replace later with Firebase fetch)
  const [data] = useState([
    {
      key: "1",
      unit: "101",
      name: "Sarah M. Brooks",
      avatar: "https://i.pravatar.cc/40?img=1",
      date: "1h ago",
      amount: "73%",
      method: "Broken Heater",
      agent: "Christa Sardina",
      property: "3822 DT Amersfoort",
      status: "New",
    },
    {
      key: "3",
      unit: "101",
      name: "Robert V. Leavitt",
      avatar: "https://i.pravatar.cc/40?img=3",
      date: "4h ago",
      amount: "40%",
      method: "Kitchen Sink Leak",
      agent: "Robert V. Leavitt",
      property: "Julianastraat ZX 7031",
      status: "Progress",
    },
    {
      key: "2",
      unit: "341",
      name: "Joe K. Hall",
      avatar: "https://i.pravatar.cc/40?img=2",
      date: "03/08/2025",
      amount: "90%",
      method: "Window Repair",
      agent: "Darren Rivera",
      property: "3181 BE Rozenburg",
      status: "Completed",
    },
    {
      key: "4",
      unit: "795",
      name: "Lydia Anderson",
      avatar: "https://i.pravatar.cc/40?img=4",
      date: "02/09/2025",
      amount: "81%",
      method: "Air Conditioner Issue",
      agent: "Lydia Anderson",
      property: "2561 DB Den Haag",
      status: "Completed",
    },
    {
      key: "5",
      unit: "472",
      name: "Jane Hanson",
      avatar: "https://i.pravatar.cc/40?img=5",
      date: "02/21/2024",
      amount: "77%",
      method: "Door Lock Problem",
      agent: "Lydia Anderson",
      property: "2561 DB Den Haag",
      status: "Completed",
    },
    {
      key: "6",
      unit: "632",
      name: "Tim Pool",
      avatar: "https://i.pravatar.cc/40?img=6",
      date: "01/02/2024",
      amount: "85%",
      method: "Water Heater Issue",
      agent: "Lydia Anderson",
      property: "2561 DB Den Haag",
      status: "Completed",
    },
  ]);

  const statusColors = {
    Progress: "orange",
    "Completed": "green",
    New: "red",
  };

  const columns = [
    {
      title: "Unit",
      dataIndex: "unit",
      key: "unit",
      render: (unit) => (
        <a onClick={() => navigate(`/landlord/listings/${unit}`)}>{unit}</a>
      ),
    },
    {
      title: "Tenant",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <Space>
          <Avatar src={record.avatar} />
          {text}
        </Space>
      ),
    },
    { title: "Received", dataIndex: "date", key: "date" },
    { title: "Issue", dataIndex: "method", key: "method" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => <Tag color={statusColors[status]}>{status}</Tag>,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space>
          <Tooltip title="View Application">
            <Button
              shape="circle"
              icon={<EyeOutlined />}
              onClick={() => navigate(`/landlord/applications/${record.key}`)}
            />
          </Tooltip>
          <Tooltip title="Review/Send Lease">
            <Button shape="circle" icon={<EditOutlined />} />
          </Tooltip>
          <Tooltip title="Reject">
            <Button shape="circle" danger icon={<DeleteOutlined />} />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Table columns={columns} dataSource={data} pagination={{ pageSize: 50 }} />
    </div>
  );
};

export default MaintenancePage;
